import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { AuthShell } from '../components/AuthShell'
import {
  PreferenceCategory,
  PreferenceInfo,
  PreferenceInput,
  PreferenceScreen,
  PreferenceSubmit,
} from '../components/Preference'
import { ensureAnonymous, needsHousehold, useMe } from '../lib/auth-client'

/** Create a new household without an account. */
export default function Start() {
  const navigate = useNavigate()
  const { data: me, isLoading } = useMe()
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (!me) return
    if (me.user?.tenantId != null) {
      navigate('/planning', { replace: true })
      return
    }
    if (needsHousehold(me)) {
      navigate('/onboarding', { replace: true })
    }
  }, [me, navigate])

  async function startHousehold() {
    setBusy(true)
    try {
      const { error: anonErr } = await ensureAnonymous()
      if (anonErr) {
        toast.error(anonErr.message || 'Kon sessie niet starten')
        return
      }
      const res = await fetch('/api/tenants', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim() || 'Mijn huishouden' }),
      })
      const data = await res.json()
      if (!res.ok) {
        toast.error(data.message || 'Mislukt')
        return
      }
      navigate('/planning', { replace: true })
    } catch (err) {
      toast.error(err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }

  if (isLoading || !me || me.user?.tenantId != null) {
    return (
      <AuthShell>
        <PreferenceInfo title="Laden…" />
      </AuthShell>
    )
  }

  return (
    <AuthShell>
      <PreferenceScreen title="Start" backHref="/">
        <PreferenceCategory filled>
          <PreferenceInput
            title="Naam huishouden"
            value={name}
            onChange={setName}
            placeholder="Wilgenstraat"
            autoFocus
          />
          <PreferenceSubmit
            title={busy ? 'Bezig…' : 'Beginnen'}
            onPress={startHousehold}
            disabled={busy}
          />
        </PreferenceCategory>
      </PreferenceScreen>
    </AuthShell>
  )
}
